import IconLib from '../components/IconLib';

const fileManager = [
    {
        name: 'Home',
        icon: <img src={IconLib.mdiHomeOutline} alt=''/>,
        to: '/',
    },
    {
        name: 'My Files',
        icon: <img src={IconLib.icOutlineFolder} alt=''/>,
        to: '/my-files',
    },
    {
        name: 'Recent', 
        icon: <img src={IconLib.iconamoonClockLight} alt=''/>,

        to: '/recent',
    },
    {
        name: 'Favorite',
        icon: <img src={IconLib.mdiStarOutline} alt=''/>,
        to: '/favorite',
    },
    {
        name: 'Trash',
        icon: <img src={IconLib.octiconTrash24} alt=''/>,

        to: '/trash',
    },
    {
        name: 'Shared with me',
        icon: <img src={IconLib.fluentPeople16Regular} alt=''/>,

        to: '/shared-with-me',
    },
    {
        name: 'Shared by me',
        icon: <img src={IconLib.fluentPerson24Regular} alt=''/>,
        to: '/shared-by-me',
    },
];

const sharedFile = [
    {
        name: 'Shared with me',
        icon: <img src={IconLib.fluentPeople16Regular} alt=''/>,

        to: '/shared-with-me',
    },
    {
        name: 'Shared by me',
        icon: <img src={IconLib.fluentPerson24Regular} alt=''/>,

        to: '/shared-by-me',
    },
];

export { fileManager, sharedFile };
